import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import type { Company } from "./types";

interface CurrentCompanyState {
	profile: Company | null;
	loading: boolean;
	error: string | null;
}

const initialState: CurrentCompanyState = {
	profile: null,
	loading: false,
	error: null,
};

const currentCompanySlice = createSlice({
	name: "currentCompany",
	initialState,
	reducers: {
		setCurrentCompanyProfile: (state, action: PayloadAction<Company>) => {
			state.profile = action.payload;
			state.loading = false;
			state.error = null;
		},
		setCurrentCompanyLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
		setCurrentCompanyError: (state, action: PayloadAction<string>) => {
			state.error = action.payload;
			state.loading = false;
		},
		clearCurrentCompany: (state) => {
			state.profile = null;
			state.loading = false;
			state.error = null;
		},
	},
});

export const {
	setCurrentCompanyProfile,
	setCurrentCompanyLoading,
	setCurrentCompanyError,
	clearCurrentCompany,
} = currentCompanySlice.actions;

export default currentCompanySlice.reducer;
